import { SvgIcon } from "../SvgIcon";

export const TickOrCross = ({ flag }) => {
  return flag ? <SvgIcon wrapperClass="status-icon active" svgClass="icon-tick" name="tick" /> : <SvgIcon wrapperClass="status-icon inactive" svgClass="icon-cross" name="cross" />;
};
